// extracted by mini-css-extract-plugin
export var button = "_el-4";
export var hasDarkBackground = "_el-7";
export var hasLightBackground = "_el-6";
export var iconWrapper = "_el-0";
export var large = "_el-2";
export var medium = "_el-1";
export var small = "_el-5";
export var xsmall = "_el-3";